import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { getSlideNotesDialogState, State } from "../reducers";
import { updateSlideNotes, UpdateSlideNotesAction } from "./slides";


export interface ShowSlideNotesDialogAction {
    readonly type: 'SHOW_SLIDE_NOTES_DIALOG',
    readonly slideUuid: string,
    readonly text: string,
}

export interface CloseSlideNotesDialogAction {
    readonly type: 'CLOSE_SLIDE_NOTES_DIALOG',
}

export interface SlideNotesDialogTextChangedAction {
    readonly type: 'SLIDE_NOTES_DIALOG_TEXT_CHANGED',
    readonly text: string,
}


export function showSlideNotesDialog(slideUuid: string, text: string): ShowSlideNotesDialogAction {
    return {
        type: 'SHOW_SLIDE_NOTES_DIALOG',
        slideUuid,
        text,
    }
}

export function closeSlideNotesDialog(): CloseSlideNotesDialogAction {
    return {
        type: 'CLOSE_SLIDE_NOTES_DIALOG',
    }
}

export function submitSlideNotesDialog(): ThunkAction<any, State, any, CloseSlideNotesDialogAction | UpdateSlideNotesAction> {
    return async (dispatch: ThunkDispatch<State, any, CloseSlideNotesDialogAction | UpdateSlideNotesAction>, getState: () => State): Promise<any> => {
        const state = getState();
        const { slideUuid, text } = getSlideNotesDialogState(state);
        dispatch(updateSlideNotes(slideUuid, text));
        dispatch(closeSlideNotesDialog());
    };
}

export function slideNotesDialogTextChanged(text: string): SlideNotesDialogTextChangedAction {
    return {
        type: 'SLIDE_NOTES_DIALOG_TEXT_CHANGED',
        text,
    }
}



// WEBPACK FOOTER //
// ./src/actions/slide_notes-dialog.ts